import { styled } from "@mui/system";
export const IconContainer = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    marginTop: "30px",
    marginBottom: "30px",
    paddingRight: "10px",
    paddingLeft: "10px",
    [theme.breakpoints.down("sm")]: {
        marginBlock: "10px",
        justifyContent: "space-between",
        padding: "0px",
        "& div": {
            width: "50px",
            height: "50px",
        },
        "& div svg": {
            width: "24px",
        },
    },
}));
export const TwitterContainer = styled("div")(({ theme }) => ({
    background: "#1DA1F210",
    borderRadius: "50px",
    height: "70px",
    width: "70px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& svg ": {
        width: "40px",
        height: "auto",
        marginTop: "10px",
    },
    "&:hover": {
        background: "#88888830",
    },
}));
export const EmailContainer = styled("div")(({ theme }) => ({
    background: "#88888810",
    borderRadius: "50px",
    height: "70px",
    width: "70px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& svg ": {
        width: "40px",
        height: "auto",
    },
    "&:hover": {
        background: "#88888830",
    },
}));
export const FacebookContainer = styled("div")(({ theme }) => ({
    background: "#ecf0f7",
    borderRadius: "50px",
    height: "70px",
    width: "70px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& svg ": {
        width: "40px",
        height: "auto",
    },
    "&:hover": {
        background: "#4267B230",
    },
}));
export const WhatsappContainer = styled("div")(({ theme }) => ({
    background: "#e9fbf0",
    borderRadius: "50px",
    height: "70px",
    width: "70px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& svg ": {
        width: "40px",
        height: "auto",
    },
    "&:hover": {
        background: "#25D36630",
    },
}));
export const LinkedInContainer = styled("div")(({ theme }) => ({
    background: "#0077B530",
    borderRadius: "50px",
    height: "70px",
    width: "70px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& svg ": {
        width: "40px",
        height: "auto",
    },
    "&:hover": {
        background: "#324ECF30",
    },
}));
export const TelegramContainer = styled("div")(({ theme }) => ({
    background: "#26A4E330",
    borderRadius: "50px",
    height: "70px",
    width: "70px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& svg ": {
        width: "40px",
        height: "auto",
    },
    "&:hover": {
        background: "#2266AA30",
    },
}));
export const SpanText = styled("span")(({ theme }) => ({
    cursor: "pointer",
    color: "blue",
    fontSize: "16px",
}));
